import { useFormikContext } from 'formik';
import React from 'react';
import { InputLabel, Poppins, Spacer } from 'src/common';
import AutoGrowingInput from 'src/components/form/AutoGrowingInput';
import { OrganisationSelect } from 'src/components/select/OrganisationSelect';
import { UpsertOrganisationMutationVariables } from 'src/graphql/_generated';
import { InputAdornment } from '@mui/material';
import useBreakpoints from 'src/hooks/useBreakpoints';

interface Step1Props {}

export const Step1: React.FC<Step1Props> = () => {
  const { values, handleBlur, handleChange, errors, touched, setFieldValue, setFieldTouched } =
    useFormikContext<UpsertOrganisationMutationVariables>();
  const isMd = useBreakpoints('md');

  return (
    <>
      <InputLabel>ORGANISATION NAME *</InputLabel>
      <AutoGrowingInput
        data-cy="org-name-input"
        name="name"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.name}
        placeholder="Organisation name"
        error={touched.name && Boolean(errors.name)}
        helperText={touched.name && errors.name}
        fullWidth
      />
      <Spacer $px={20} />
      <InputLabel>PRIMARY CONTACT EMAIL ADDRESS *</InputLabel>
      <AutoGrowingInput
        data-cy="org-primary-contact-input"
        type="email"
        name="primaryContact"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.primaryContact}
        placeholder="Primary contact email address"
        error={touched.primaryContact && Boolean(errors.primaryContact)}
        helperText={touched.primaryContact && errors.primaryContact}
        fullWidth
      />
      <Spacer $px={20} />
      <InputLabel>BILLING CONTACT EMAIL ADDRESS</InputLabel>
      <AutoGrowingInput
        type="email"
        name="billingContact"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.billingContact}
        placeholder="Billing contact email address"
        error={touched.billingContact && Boolean(errors.billingContact)}
        helperText={touched.billingContact && errors.billingContact}
        fullWidth
      />
      <Spacer $px={20} />
      <InputLabel>ORGANISATION EMAIL DOMAIN *</InputLabel>
      <AutoGrowingInput
        data-cy="org-domain-input"
        name="domain"
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.domain}
        placeholder="Organisation email domain"
        error={touched.domain && Boolean(errors.domain)}
        helperText={touched.domain && errors.domain}
        fullWidth
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start" style={{ left: isMd ? 10 : 12, position: 'absolute' }}>
                <Poppins px={16} weight={500} color="cflowerBlue">
                  @
                </Poppins>
              </InputAdornment>
            ),
          },
        }}
      />
      <Spacer $px={20} />
      <InputLabel>PARENT ORGANISATION</InputLabel>
      <div data-cy="org-parent-select">
        <OrganisationSelect
          placeholder="Parent organisation"
          value={String(values.parentId)}
          onChange={(o) => {
            setFieldValue('parentId', o.value);
            setTimeout(() => setFieldTouched('parentId', true));
          }}
        />
      </div>
    </>
  );
};
